import React, { useState, useRef } from 'react';
import Loading from '@catalogo/ui-americanas-mobile-loading';
import styled from 'styled-components';
import withReviewProduct from '@catalogo/service-americanas-product-review/src/legacy/hocs/withReviewProduct';
import { Wrapper } from '@catalogo/theme-wrapper';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box';
import Review from './components/review';
import Header from './components/header';
import NoReviews from './components/no-reviews';

const WrapperLoad = styled.div`
  position: relative;
  height: 200px;
  width: 100%;

  > div {
    position: relative;
  }
`;

const WrapperReview = styled.div`
  background-color: #fff;
`;

const WrapperLoadMore = styled.div`
  display: flex;
  justify-content: center;
  margin: 25px;
`;

const LoadMore = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  border: 2px solid ${({ theme }) => theme.primaryColor};
  background: #fff;
  border-radius: 8px;
  padding: 4px 16px;
  width: 100%;
  height: 44px;
  color: ${({ theme }) => theme.primaryColor};
  outline: none;
  font-size: 16px;

  &:focus {
    outline: none;
  }
`;

const ReviewsLoad = () => (
  <WrapperLoad>
    <Loading />
  </WrapperLoad>
);

const LoadMoreButton = ({ filters, isLoadingMore, loadMoreReviews }) => (
  <WrapperLoadMore>
    {isLoadingMore ? (
      <Loading position="relative" />
    ) : (
      <LoadMore onClick={() => loadMoreReviews(filters)}>Ver mais avaliações</LoadMore>
    )}
  </WrapperLoadMore>
);

const ProductReviewPage = ({
  productId,
  reviews,
  loadMoreReviews,
  isLoadingMore,
  showLoadMore,
  rating,
  recommended,
  fetchMore,
  loading,
  hasReviewsStored,
  ratingDistribution,
}) => {
  const ref = useRef(null);
  const [filters, setFilters] = useState({});
  const setFilterLoadMore = (filterRating, filterSort) => {
    setFilters({ filterRating, filterSort });
  };

  return (
    <AccordionBox
      ref={ref}
      title="Avaliações"
      shouldGetElementHeightOnRender={false}
      visibilityOnInit={true}
      metricId="review"
      paddingContentAxisX={0}
      id="card-reviews-title"
      hashRef="#card-reviews-title"
    >
      {(!hasReviewsStored && reviews?.length < 1) || !rating ? (
        <NoReviews productId={productId} />
      ) : (
        <Wrapper>
          <WrapperReview>
            <Header
              reviews={reviews}
              rating={rating}
              productId={productId}
              fetchMore={fetchMore}
              recommended={recommended}
              setFilterLoadMore={setFilterLoadMore}
              ratingDistribution={ratingDistribution}
            />
            {loading && ReviewsLoad()}
            {!loading && reviews?.map(review => <Review productId={productId} key={review.date} {...review} />)}
            {showLoadMore && (
              <LoadMoreButton filters={filters} isLoadingMore={isLoadingMore} loadMoreReviews={loadMoreReviews} />
            )}
          </WrapperReview>
        </Wrapper>
      )}
    </AccordionBox>
  );
};

export default withReviewProduct(ProductReviewPage);
export { ProductReviewPage };
